__turbopack_context__.v({
  "desktopOnlyGrid": "ProductGridBlok-module__Jl5M1G__desktopOnlyGrid",
  "mobileOnlyCarousel": "ProductGridBlok-module__Jl5M1G__mobileOnlyCarousel",
  "root": "ProductGridBlok-module__Jl5M1G__root",
  "title": "ProductGridBlok-module__Jl5M1G__title",
});
